// 會員系統連結
import { useSelector, useDispatch } from 'react-redux';
import { setShowComingModal } from '@/slices/popSlice';
import { urlState } from '@/slices/urlSlice';

const UserMemberLink = ({ t }) => {
    const { memberUrl } = useSelector(urlState);
    const dispatch = useDispatch();

    return (
        <div
            className="my-[16px] space-y-[16px] [&>div]:flex [&>div]:gap-x-[16px] text-btn1 text-white [&>div>*]:w-full [&>div>*]:px-[20px] [&>div>*]:py-[14px]
            [&>div>*]:border-1 [&>div>*]:border-black2 [&>div>*]:border-opacity-[.4] [&>div>*]:rounded-[4px] [&>div>*]:trans [&>div>*]:text-center"
        >
            <div>
                <a
                    href={memberUrl + '/profile'}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="trans hover:border-bou hover:bg-bou hover:text-white"
                >
                    {t('FILE')}
                </a>
                <a
                    href={memberUrl + '/collection'}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="trans hover:border-bou hover:bg-bou hover:text-white"
                >
                    {t('NEWS_COLLECT')}
                </a>
            </div>

            <div>
                <a
                    href={memberUrl + '/account-security'}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="trans hover:border-bou hover:bg-bou hover:text-white"
                >
                    {t('ACCOUNT')}
                </a>
                <button
                    title={t('COMING')}
                    onClick={() => dispatch(setShowComingModal('FORUM'))}
                    className="trans hover:border-bou hover:bg-bou hover:text-white"
                >
                    {t('RECREATION_COLLECT')}
                </button>
            </div>
        </div>
    );
};

export default UserMemberLink;
